import { DOWNLOAD_MODAL } from './downloadModal';
import { REDEMPTION_MODAL } from './redemptionModal';
import { REWARD_CARD } from './rewardCard';
import { VIEW_REWARD } from './viewReward';

export const REDEEM = { REWARD_CARD, REDEMPTION_MODAL, DOWNLOAD_MODAL, VIEW_REWARD };
